import { LocationDescriptor } from 'history'
import React from 'react'
import { SectionHeaderProps } from '../../section-header/SectionHeader/SectionHeader'
import {
    StyledHeading,
    StyledSeeAllLink,
    StyledWebLink,
} from './BauhausSectionHeader.styled'

export interface BauhausSectionHeaderProps {
    sectionHeader: SectionHeaderProps
    hasBackground?: boolean
    displaySeeAll?: boolean
    textCenter?: boolean
}

export const BauhausSectionHeader: React.FC<BauhausSectionHeaderProps> = (
    props: BauhausSectionHeaderProps,
) => {
    const { sectionHeader, hasBackground, displaySeeAll, textCenter } = props

    return (
        <StyledHeading hasBackground={hasBackground} textCenter={textCenter}>
            {sectionHeader.headingUrl ? (
                <>
                    <StyledWebLink
                        to={sectionHeader.headingUrl as LocationDescriptor}
                    >
                        {sectionHeader?.heading}
                    </StyledWebLink>
                    <StyledSeeAllLink
                        to={sectionHeader.headingUrl as LocationDescriptor}
                    >
                        {displaySeeAll && <span>See All</span>}
                    </StyledSeeAllLink>
                </>
            ) : (
                sectionHeader?.heading
            )}
        </StyledHeading>
    )
}

BauhausSectionHeader.displayName = 'BauhausSectionHeader'
